import { Application, Controller } from 'stimulus'

class Tab {
  constructor (title, family) {
    this.config = this.loadConfig(title, family)
    this.title = title
    this.family = family
    this.body = family.container.querySelectorAll(this.config.content)
    this.bindEvents()
  }

  loadConfig (title, family) {
    const familyConfig = family.config
    const activeClass = familyConfig.activeClass
    const config = title.dataset || {}
    if (!config.activeClass) { config.activeClass = activeClass }
    return config
  }

  on () {
    this.title.querySelector('[is=x-tab]').classList.add(this.config.activeClass)
    this.body.forEach((content) => content.style.display = 'block')
    return this
  }

  off () {
    this.title.querySelector('[is=x-tab]').classList.remove(this.config.activeClass)
    this.body.forEach((content) => content.style.display = 'none')
    return this
  }

  pushUrl () {
    const urlBase = window.location.href.split("#")[0]
    const newUrl = `${urlBase}#${this.config.urlAnchor}`
    window.location.href = newUrl
  }

  bindEvents () {
    this.title.addEventListener('click', () => {
      this.family.select(this)
      if (this.config.urlAnchor) {
        this.pushUrl()
      }
    })
  }
}

class SeoTabsControlller extends Controller {
  connect () {
    this.container = this.element.parentNode
    this.config = this.element.dataset || {}
    this.all = this.initAllTabs()
    this.current = this.initCurrentTab()
  }

  initAllTabs () {
    const titleSelector = this.config.tabsSelector
    const tabTitles = Array.from(this.element.querySelectorAll(titleSelector))
    return tabTitles.map(title => new Tab(title, this).off())
  }

  initCurrentTab () {
    const currentTab = this.findByUrlAnchor()
    if (currentTab) { return currentTab.on() }
    const selector = `${this.config.tabsSelector}${this.config.selected}`
    const title = this.element.querySelector(selector) || this.element.children[0]
    return new Tab(title, this).on()
  }

  select (tab) {
    this.current.off()
    this.current = tab.on()
  }

  findByUrlAnchor () {
    const urlAnchor =  window.location.href.split('#')[1]
    if (urlAnchor) {
      return (this.all.filter(tab => tab.config.urlAnchor === urlAnchor))[0]
    }
  }
}

const application = Application.start()
application.register('seo-tabs', SeoTabsControlller)
